<template>
  <div v-if="schedulingConfig.data">
    <Icon
      :width="70"
      :height="70"
      class="mb-5"
      :icon="'calendar-multiple-check'"
    />
    <h3 class="font-weight-bold mb-2">
      {{ schedulingConfig.data.title }}
    </h3>

    <div v-if="($route.query.guestReceiveInvitation === 'true')">
      <i18n
        v-if="!schedulingConfig.data.description"
        path="thankYouPage.scheduling.description"
        tag="p"
        class="text--secondary pb-5"
      >
        <b
          v-if="$store.state.storage.room.customer.email"
          v-html="$store.state.storage.room.customer.email + '.'"
        ></b>
      </i18n>
      <span
        v-if="schedulingConfig.data.descriptionText"
        class="text--secondary pb-5"
      >
        <font v-html="schedulingConfig.data.descriptionText"></font>
        <b
          v-if="$store.state.storage.room.customer.email"
          v-html="$store.state.storage.room.customer.email"
        ></b>.
      </span>
    </div>
    <div v-else>
      <p class="text--secondary pb-5">
        {{ $t('thankYouPage.schedulingNotNotify.description') }}
      </p>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import OcGoogleAnalytics from '@/plugins/OcGoogleAnalitycs'

@Component({
  components: {
    Icon: () => import(/* webpackPrefetch: true */ '@/components/Icon.vue')
  },
  computed: {
    schedulingConfig () {
      return this.$organization.schedulingConfig()
    }
  },
})
export default class Scheduling extends Vue {
  mounted () {
    this.ocGoogleAnalyticsInit()
  }

  ocGoogleAnalyticsInit () {
    OcGoogleAnalytics.getDataLayerConfig('scheduling-mounted')
  }


}
</script>
